import styled from 'styled-components'
import TextField from '@mui/material/TextField';

export const Input = styled(TextField)`
    margin-bottom: 10px !important;
    width: 100%;
`